import { SVG } from 'assets/imagePath';
import Button from 'components/button';
import { BREAKPOINT } from 'constant/breakpoints';
import { useViewport } from 'context/ViewportContext';
import { useAuth } from 'hooks/useAuth';
import { FC, memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  className?: string;
  toggle: boolean;
  setToggle?: (prev: boolean) => void;
};

const HeaderOrganization: FC<Props> = ({ className, toggle, setToggle }) => {
  const navigate = useNavigate();
  const { CURRENT_ROLE, currentUser } = useAuth();
  const { width } = useViewport();

  useEffect(() => {
    // if (width < BREAKPOINT.lg) {
    //   setToggle(false);
    // } else {
    //   setToggle(true);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  return (
    <div className="flex justify-between">
      <ul className="flex flex-1 items-center list-none justify-between text-center gap-2.5">
        <li>
          <Button.Icon
            classNameIcon="!icon-app"
            icon={toggle ? SVG.filter : SVG.unfilter}
            variant="outlined"
            className="bg-[#f3f3f3]"
            onClick={() => setToggle(!toggle)}
          />
        </li>
        <li className="flex gap-[5px]">
          <div>
            <Button.White
              className="!p-default"
              color="white"
              label="Organization List - Mgr."
              icon={SVG.chevron_down}
              onClick={() => {}}
            />
          </div>
          {CURRENT_ROLE === 'SYSTEM_ADMIN' && (
            <div>
              <Button.Primary
                className="!p-default"
                label={
                  <p>
                    Inquires <span className="font-bold">(3)</span>
                  </p>
                }
                onClick={() => {}}
              />
            </div>
          )}
        </li>
      </ul>
      <p className="hidden lg:flex flex-1 justify-center items-center text-xs text-black font-bold">
        Betty MacDonald – MRG
      </p>

      <ul className="flex flex-1 items-center justify-end list-none text-center gap-2.5">
        <li>
          <Button.Primary
            label="Add Organization"
            onClick={() => navigate('/organizations/edit/new')}
          />
        </li>
      </ul>
    </div>
  );
};
HeaderOrganization.displayName = 'Header.Organization';
export default memo(HeaderOrganization);
